// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_2l-6";
export var headerCell = "_2l-2";
export var loadingStateContent = "_2l-8";
export var rowWrapper = "_2l-4";
export var stickyAggregationCell = "_2l-b";
export var stickyAggregationRow = "_2l-7";
export var stickyColumnCell = "_2l-a";
export var stickyColumnHeaderCell = "_2l-9";
export var table = "_2l-1";
export var virtualRowWrapper = "_2l-5";
export var virtualTableContainer = "_2l-0";
export var white = "_2l-3";